export const MAPBOX_URL = 'https://api.mapbox.com';

export const ADMINISTRATIVE_TYPE = {
  COUNTRY: `country`,
  REGION: `region`,
  POSTCODE: `postcode`,
  DISTRICT: `district`,
  PLACE: `place`,
  CITY: `city`,
  LOCALITY: `locality`,
  NEIGHBORHOOD: `neighborhood`, // seems to be POI (point of interest)
  STREET: `street`,
  ADDRESS: `address`,
  POI: `poi`,
} as const;
export type AdministrativeType = typeof ADMINISTRATIVE_TYPE[keyof typeof ADMINISTRATIVE_TYPE];

export const ADMINISTRATIVE_TYPE_VALUES_ADDRESS = [
  ADMINISTRATIVE_TYPE.STREET,
  ADMINISTRATIVE_TYPE.ADDRESS,
] as const;
